// @flow
// API Public Evaluations static class
const apiBasePublicEvaluations = "/evaluations/public";
export default class PublicUrl {
  // Get Data for some public evaluation
  static GetPublicEvaluationsDatas(api: Object, publicToken: string) {
    return api.GET(`${apiBasePublicEvaluations}/${publicToken}`);
  }
  // Get Targets (Rotations | Students) for some public evaluation
  static GetPublicEvaluationsTargets(
    api: Object,
    evaluationSchedulerId: string,
    targetsPath: string,
    publicToken: string
  ) {
    // return { success: true, data: rotationsResponse };
    return api.GET(
      `/evaluation-schedulers/public/${evaluationSchedulerId}/${targetsPath}`,
      { Publicid: publicToken }
    );
  }
  // Submit Answers for some public evaluation
  static SubmitPublicEvaluationsAnswers(
    api: Object,
    publicToken: string,
    data: Object
  ) {
    return api.POST(`${apiBasePublicEvaluations}/${publicToken}/answers`, data);
  }
}

const targetsResponse = {
  ok: true,
  targets: [
    {
      _id: "660d81d0dc52f51628c23df8",
      firstName: "Alexa",
      lastName: "Dray",
      role: "Students",
    },
    {
      _id: "660d81d0dc52f51628c23dfc",
      firstName: "Alicia",
      lastName: "Dennie",
      role: "Students",
    },
    {
      _id: "660d81cfdc52f51628c23ddb",
      firstName: "Nio",
      lastName: "Baltzell",
      role: "Students",
    },
    {
      _id: "660d81cfdc52f51628c23dcb",
      firstName: "Roua",
      lastName: "Almosawi",
      role: "Students",
    },
  ],
};

const rotationsResponse = {
  ok: true,
  rotations: [
    {
      _id: "66280089016fbf432d43cc53",
      institutions: [
        { _id: "64ef5872594601630df8d436", name: "Gosport Dental Clinic" },
      ],
      student: {
        _id: "660d81cfdc52f51628c23dc9",
        email: "emhugh@iu.edu",
        role: "Students",
        company: "64e3c60c119c48667a1bcd4e",
        firstName: "Emily",
        lastName: "Hughes",
        customFields: [
          { field: "65cfc6590f8c1844f028b160", value: true },
          { field: "65cfc6690f8c1844f028b161", value: true },
          { field: "65cfc6760f8c1844f028b162", value: true },
        ],
        studentNumber: "S25144",
        activeRotation: null,
        status: "active",
        customerId: null,
        files: [],
        isEvaluator: false,
        kind: "Students",
        createdAt: "2024-04-03T16:20:31.327Z",
        updatedAt: "2024-04-03T16:20:34.361Z",
        profileImageOriginal: null,
        profileImage320: null,
      },
      enrollment: "661e92174605003e917784ab",
      start: "2024-07-08T00:00:00.000Z",
      end: "2024-07-12T23:59:59.999Z",
      status: "upcoming",
      rotationNumber: "821b9968ac73ea299b1c",
      createdAt: "2024-04-23T18:40:09.234Z",
      evaluations: [],
    },
    {
      _id: "66280089016fbf432d43cc50",
      institutions: [
        { _id: "64ef7150594601630df8d526", name: "Trinity Free Clinic" },
      ],
      student: {
        _id: "660d81cfdc52f51628c23dc9",
        email: "emhugh@iu.edu",
        role: "Students",
        company: "64e3c60c119c48667a1bcd4e",
        firstName: "Emily",
        lastName: "Hughes",
        customFields: [
          { field: "65cfc6590f8c1844f028b160", value: true },
          { field: "65cfc6690f8c1844f028b161", value: true },
          { field: "65cfc6760f8c1844f028b162", value: true },
        ],
        studentNumber: "S25144",
        activeRotation: null,
        status: "active",
        customerId: null,
        files: [],
        isEvaluator: false,
        kind: "Students",
        createdAt: "2024-04-03T16:20:31.327Z",
        updatedAt: "2024-04-03T16:20:34.361Z",
        profileImageOriginal: null,
        profileImage320: null,
      },
      enrollment: "661e92174605003e917784ab",
      start: "2024-06-03T00:00:00.000Z",
      end: "2024-06-14T23:59:59.999Z",
      status: "upcoming",
      rotationNumber: "1933d5e6b54eb99af439",
      createdAt: "2024-04-23T18:40:09.157Z",
      evaluations: [],
    },
  ],
  metadata: { upcoming: 2, incourse: 0, finished: 0, skip: 0, limit: 20 },
};
